exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".button-input{width:13rem;height:13rem}.button-input .MuiButton-label{text-transform:none}.button-input .MuiButton-label svg{margin:1rem}.button-input .MuiButton-label .title{font-size:1rem;font-weight:500;margin-bottom:.5rem;line-height:1.4rem}@media(max-width: 575px){.button-input .MuiButton-label .title{margin:0}}.button-input .MuiButton-label .subtitle{font-size:11px;line-height:.85rem;margin-bottom:.5rem}@media(max-width: 575px){.button-input{width:10rem;height:10rem}.button-input .MuiButton-label .title{font-size:.88rem}.button-input .MuiButton-label svg{margin:0}.button-input.wide-sm{width:100%;height:unset}}.button-input.inactive .check{visibility:hidden}.button-input.active{background-color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Quoters/PreQuote/ButtonInput/ButtonInput.scss
// module id = 7561
// module chunks = 11